var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _vm.action === "attach-files"
        ? _c("okil-file-sender", {
            attrs: {
              busy: _vm.busy,
              params: _vm.params.params,
              extra: _vm.params.extra,
            },
            on: { send: _vm.dispatch },
          })
        : _vm.action === "barcode-scanner"
        ? [
            !_vm.busy
              ? _c("okil-barcode-scanner", {
                  attrs: {
                    "acceptor-name": _vm.barcodeAcceptorName,
                    result: _vm.scanner.result,
                  },
                  on: {
                    onLoaded: _vm.onScannerLoaded,
                    onDecode: _vm.dispatch,
                    close: _vm.close,
                  },
                })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.dialog.open
        ? _c("core-loading-dialog", {
            attrs: {
              "error-title": _vm.dialog.title,
              "error-message": _vm.dialog.message,
            },
            on: { close: _vm.closeDialog },
          })
        : _vm._e(),
      _vm.confirmDialog.initiator === _vm.$options.name &&
      _vm.confirmDialog.question !== undefined
        ? _c("core-confirm-dialog", {
            attrs: {
              title: _vm.confirmDialog.title,
              fullscreen: false,
              question: _vm.confirmDialog.question,
              buttons: _vm.confirmDialog.buttons,
            },
            on: { confirm: _vm.closeConfirmDialog },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }